var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.controller.center != null)?_c('google-map',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"center":_vm.controller.center,"zoom":15,"map-type-id":"hybrid","options":_vm.$vuetify.theme.isDark ? _vm.mapDark : _vm.mapLight}},[_c('google-marker',{attrs:{"position":_vm.controller.center}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }